import api from '@/utils/api'
import STATUS from '@/utils/status'
import Vue from 'vue'

let actions = {
  loadSharedObject (ctx, {kind, id, viewers}) {
    let promise = null
    // promise = new Promise((resolve, reject) => {
    //   api.get('sharedObject/' + kind + '/' + id).then((response) => {
    //     resolve(response.data.sharedObject)
    //   }).catch(reject)
    // })
    if (kind === 'conversation') {
      promise = ctx.dispatch('conversations/getConversation', id, {root: true})
    } else if (kind === 'event') {
      promise = ctx.dispatch('events/getEvent', id, {root: true})
    } else if (kind === 'poll') {
      promise = ctx.dispatch('polls/getPoll', id, {root: true})
    } else if (kind === 'file') {
      promise = new Promise((resolve, reject) => {
        api.get(`/file/${id}`).then((response) => {
          resolve(response.data)
        }).catch(reject)
      })
    }
    if (promise) {
      if (viewers) {
        promise = new Promise((resolve, reject) => {
          promise.then((object) => {
            Vue.set(object, 'viewers', {
              status: STATUS.LOADING,
              data: []
            })
            api.get('/sharedObjectViewers/' + kind + '/' + id).then((response) => {
              object.viewers.data = response.data.users
              object.viewers.status = STATUS.LOADED
              resolve(object)
            }).catch(reject)
          }).catch(reject)
        })
      }
    }
    return promise
  },
  togglePublish (ctx, object) {
    let old = object.public
    object.public = !object.public
    let kind = object.kind
    let promise = null
    if (object.kind === 'event') {
      promise = api.put('event/' + object.id, {
        'publishOnGroupPage': object.public
      })
    } else if (kind === 'file') {
      promise = api.put('node', {
        'id': object.id,
        'kind': object.kind,
        'public': object.public
      })
    } else {
      promise = new Promise((resolve, reject) => {
        object.public = old
        resolve()
      })
    }
    promise.catch(response => {
      object.public = old
    })
    return promise
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/sharedObjects.js